<template>
  <div>
    <div class="main_wrap">
      <div class="head_wrap">404</div>
      <div class="foot_wrap"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      shown: {},
      pageData: {},
      formData: {},
    };
  },
  mounted() {
    document.title = this.$t("App.title.notfound");
  },
  methods: {},
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/exception/NotFound.vue